/**
 * Per-org hintless session minting policy. Admin-only; the ops-api 403 is
 * the real gate.
 */
import type {
  OrgSessionPolicyResponse,
  PutOrgSessionPolicyRequest,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

function path(orgId: string): string {
  return `/v1/ops/orgs/${encodeURIComponent(orgId)}/session-policy`;
}

export async function getOrgSessionPolicy(
  orgId: string,
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<OrgSessionPolicyResponse> {
  return opsApiRequest<OrgSessionPolicyResponse>(path(orgId), { signal }, fetchImpl);
}

export async function putOrgSessionPolicy(
  orgId: string,
  body: PutOrgSessionPolicyRequest,
  fetchImpl: typeof fetch,
): Promise<OrgSessionPolicyResponse> {
  return opsApiRequest<OrgSessionPolicyResponse>(path(orgId), { method: 'PUT', body }, fetchImpl);
}

export async function deleteOrgSessionPolicy(
  orgId: string,
  fetchImpl: typeof fetch,
): Promise<OrgSessionPolicyResponse> {
  return opsApiRequest<OrgSessionPolicyResponse>(path(orgId), { method: 'DELETE' }, fetchImpl);
}
